"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaterialIcon = void 0;
var MaterialIcon;
(function (MaterialIcon) {
    MaterialIcon["ADD"] = "add";
    MaterialIcon["ASSIGN"] = "how_to_reg";
    MaterialIcon["BRIGHTNESS_HIGH"] = "brightness_high";
    MaterialIcon["BRIGHTNESS_LOW"] = "brightness_low";
    MaterialIcon["BRIGHTNESS_MEDIUM"] = "brightness_medium";
    MaterialIcon["CHECK"] = "check";
    MaterialIcon["CHECK_BOX"] = "check_box_outline_blank";
    MaterialIcon["CHECK_BOX_INDETERMINATE"] = "indeterminate_check_box";
    MaterialIcon["CHECK_BOX_SELECTED"] = "check_box";
    MaterialIcon["CHECK_CIRCLE"] = "check_circle_outline";
    MaterialIcon["CLOSE"] = "close";
    MaterialIcon["CONTENT_COPY"] = "content_copy";
    MaterialIcon["CONTENT_PASTE"] = "content_paste";
    MaterialIcon["COPY_SUBFORM"] = "file_copy";
    MaterialIcon["DATE"] = "date_range";
    MaterialIcon["BEARING"] = "nat";
    MaterialIcon["DASHBOARD"] = "dashboard";
    MaterialIcon["DELETE"] = "delete";
    MaterialIcon["DEPARTMENT"] = "domain";
    MaterialIcon["DONE_ALL"] = "done_all";
    MaterialIcon["DUPLICATE"] = "file_copy";
    MaterialIcon["EDIT"] = "mode_edit";
    MaterialIcon["EDIT_LOCATION"] = "edit_location";
    MaterialIcon["EXIT_TO_APP"] = "exit_to_app";
    MaterialIcon["FIELD_DATE"] = "date_range";
    MaterialIcon["FIELD_FORM"] = "ballot";
    MaterialIcon["FIELD_HEIGHT"] = "vertical_align_top";
    MaterialIcon["FIELD_IMAGE"] = "photo_camera";
    MaterialIcon["FIELD_LOCATION"] = "my_location";
    MaterialIcon["FIELD_NESTED_LIST"] = "view_quilt";
    MaterialIcon["FIELD_NUMBER"] = "looks_one";
    MaterialIcon["FIELD_SELECT_LIST"] = "view_list";
    MaterialIcon["FIELD_TEXT"] = "font_download";
    MaterialIcon["FIELD_TRUE_SIZE"] = "camera";
    MaterialIcon["FIELD_VECTOR"] = "directions";
    MaterialIcon["FIELD_YES_NO"] = "check_box";
    MaterialIcon["FILE_DOWNLOAD"] = "file_download";
    MaterialIcon["FILE_UPLOAD"] = "file_upload";
    MaterialIcon["FILTER_NONE"] = "filter_none";
    MaterialIcon["FOLDER"] = "folder";
    MaterialIcon["FOLDER_OPEN"] = "folder_open";
    MaterialIcon["GPS_FIXED"] = "gps_fixed";
    MaterialIcon["GPS_OFF"] = "gps_off";
    MaterialIcon["GPS_ON"] = "gps_not_fixed";
    MaterialIcon["INBOX"] = "inbox";
    MaterialIcon["HELP"] = "help";
    MaterialIcon["HELP_OUTLINE"] = "help_outline";
    MaterialIcon["INFO"] = "info_outline";
    MaterialIcon["INFO_FILLED"] = "info";
    MaterialIcon["KEY_DOWN"] = "keyboard_arrow_down";
    MaterialIcon["KEY_LEFT"] = "keyboard_arrow_left";
    MaterialIcon["KEY_RIGHT"] = "keyboard_arrow_right";
    MaterialIcon["KEY_UP"] = "keyboard_arrow_up";
    MaterialIcon["LASER"] = "flare";
    MaterialIcon["LOCATION"] = "location_on";
    MaterialIcon["LOCK"] = "lock";
    MaterialIcon["MAGIC_WAND"] = "auto_fix_high";
    MaterialIcon["MANAGE_HISTORY"] = "manage_history";
    MaterialIcon["MAP"] = "map";
    MaterialIcon["MASK"] = "select_all";
    MaterialIcon["MORE_VERT"] = "more_vert";
    MaterialIcon["MOVE"] = "forward";
    MaterialIcon["MENU"] = "menu";
    MaterialIcon["NAVIGATE_NEXT"] = "navigate_next";
    MaterialIcon["NAVIGATE_PREV"] = "navigate_before";
    MaterialIcon["NONE"] = "";
    MaterialIcon["ORG_SEARCH"] = "youtube_searched_for";
    MaterialIcon["PERSON"] = "person";
    MaterialIcon["PERSON_BLACK"] = "person_black";
    MaterialIcon["PHOTO_MEASURE"] = "straighten";
    MaterialIcon["POLE_BASE"] = "vertical_align_bottom";
    MaterialIcon["PUBLIC"] = "public";
    MaterialIcon["RADIO"] = "radio_button_unchecked";
    MaterialIcon["RADIO_SELECTED"] = "radio_button_checked";
    MaterialIcon["SAVE"] = "save_alt";
    MaterialIcon["SEARCH"] = "search";
    MaterialIcon["SELECT"] = "call_made";
    MaterialIcon["SPARKLE"] = "auto_awesome";
    MaterialIcon["HIDE_PHOTO"] = "hide_image";
    MaterialIcon["SHORT_TEXT"] = "short_text";
    MaterialIcon["SORT"] = "sort_by_alpha";
    MaterialIcon["SPAN_LINK"] = "format_size";
    MaterialIcon["STATUS"] = "flag";
    MaterialIcon["TAG"] = "more";
    MaterialIcon["TAG_GROUP"] = "group_work";
    MaterialIcon["TAG_JOB"] = "folder";
    MaterialIcon["UPDATE"] = "update";
    MaterialIcon["VERTICAL_DISTRIBUTE"] = "vertical_distribute";
    MaterialIcon["VERTICAL_SEPARATION"] = "swap_vert";
    MaterialIcon["VISIBILITY_OFF"] = "visibility_off";
    MaterialIcon["ZOOM_IN"] = "zoom_in";
    MaterialIcon["ZOOM_OUT"] = "zoom_out";
    MaterialIcon["ZOOM_OUT_MAP"] = "zoom_out_map";
    MaterialIcon["SET_CROP"] = "aspect_ratio";
    MaterialIcon["REMOVE"] = "remove";
    MaterialIcon["SQUARE_FOOT"] = "square_foot";
    MaterialIcon["FORM_UPDATE"] = "assignment_turned_in";
    MaterialIcon["CLOUD_UPLOAD"] = "cloud_upload";
    MaterialIcon["FIELD_ANCHOR"] = "architecture";
    MaterialIcon["WARNING"] = "warning";
    MaterialIcon["VISIBILITY"] = "visibility";
    MaterialIcon["CLIPBOARD"] = "assignment";
})(MaterialIcon || (exports.MaterialIcon = MaterialIcon = {}));
//# sourceMappingURL=icons.js.map